import TableHeaderHtmlCustom from '../../../../components/common/customTable/TableHeaderHtmlCustom';
import { useQuery } from '../../../../hooks/UseQuery';
import { moduleConstant } from '../constant';

const style1 = {
  backgroundColor: '#4F81BD',
  color: '#fff',
  minWidth: '100px',
  height: '50px',
};
const style2 = {
  backgroundColor: '#868e96',
  height: '50px',
  color: '#fff',
};

interface IProps {
  isView: boolean;
}

const THead = ({ isView }: IProps) => {
  const date = useQuery('date');
  const year = date && new Date(date).getFullYear();
  const tableHeaderObj = [
    [
      {
        text: `${moduleConstant?.heading} - ${year}`,
        style: style2,
        colspan: 14 + (!isView ? 1 : 0),
      },
    ],
    [
      { text: 'DATE', style: style1 },
      { text: 'S.NO.', style: style1 },
      { text: 'PART NAME', style: style1 },
      { text: 'PART NO.', style: style1 },
      { text: 'CUSTOMER NAME', style: style1 },
      { text: 'QTY.', style: style1 },
      { text: 'DISCRIPTION OF NON CONFIRMIRTY', style: style1 },
      { text: 'POSSIBLE REASON', style: style1 },
      { text: 'DISPOSITION REQUIRED ( ACCEPTED AS IT IS )', style: style1 },
      { text: 'SIGN. (PROD.)', style: style1 },
      { text: 'SIGN. (QA)', style: style1 },
      { text: 'SIGN. (STORE)', style: style1 },
      { text: 'SIGN. (PLANT HEAD)', style: style1 },
      { text: 'REMARKS', style: style1 },
    ],
  ];

  if (!isView) {
    tableHeaderObj[1].push({ text: 'ACTION', style: style1, colspan: 1 });
  }

  return (
    <thead>
      <TableHeaderHtmlCustom tableHeaderObj={tableHeaderObj} />
    </thead>
  );
};

export default THead;
